import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-external-apis',
  templateUrl: './external-apis.component.html',
  styleUrls: ['./external-apis.component.scss'],
})
export class ExternalApisComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
